module.exports = __webpack_public_path__ + "static/media/popular-5.b6c93166.svg";